import request from '@/utils/request';


export async function registerFCMToken(token: string) {
  return request<API.RegisterFCMTokenResult>(`/api/notification/register_fcm_token`, {
    method: 'POST',
    data: { fcm_token: token },
  });
} 


export async function fetchNotifications() {
  return request<API.FetchNotificationsResult>(`/api/notification/notifications`, {
    method: 'GET',
  });
} 


export async function markAsRead(notificationId: string) {
  return request<API.MarkAsReadResult>(`/api/notification/mark_as_read/${notificationId}`, {
    method: 'GET',
  });
} 

